import React, { Component } from "react";
import {
  InputGroup,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Pagination from "react-js-pagination";
import * as congNoAction from './actions'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate, getParam, abs2number } from "../../lib/common";
import CheckboxTreeList from "../controls/_CheckboxTreeList";
const isNumber = require('is-number');

class CongNoNhanVienByKh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate().endOf("days"),
      list: [],
      total_record: 0,
      page: 1,
      per_page: 20,
      total: {},
      keyword: "",
      nvId: 0,
      listNvkd: [],
      TinhThanhId: "",
      selectedOptionNhanVien: [],
      khId: 0,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  handleDateChange = (e, name) => {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  onHandleRemoveNvkd = () => {
    this.setState({ nvId: 0, selectedOptionNhanVien: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    this.setState({ nvId: nodesChecked.length > 0 ? nodesChecked[0].value : 0 }, () => {
    })
  }
  handleChangeNhanVien = selectedOptionNhanVien => {
    let option = selectedOptionNhanVien || { value: 0 }
    this.setState({ selectedOptionNhanVien: option, nvId: option.value });
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  fetchList(page) {
    var requestData = {
      nvId: this.state.nvId,
      fromDate: this.state.tuNgay.unix(),
      toDate: this.state.denNgay.endOf('days').unix(),
      page: page || this.state.page,
      per_page: this.state.per_page,
    }
    const onSuccess = ({ records, total_record }) => {
      const sumTotal = total_record ? total_record[0] : {}
      this.setState(
        {
          total_record: sumTotal.totalRecord,
          list: records,
          total: sumTotal,
        }
      )
    }
    this.props.congNoNhanVienByKhListRequest(requestData, onSuccess)
  }
  exportXls = () => {
    var requestData = {
      nv: this.state.nvId,
      t: this.state.tuNgay.unix(),
      d: this.state.denNgay.endOf('days').unix()
    };
    this.props.congNoNvExportXlsRequest(requestData, (item) => {
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportCongNoNv';
      var fileName = "CongNoNhanVien.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportCongNoNv";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.congNoNhanVienByKh.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  fetchNvkd = () => {
    const { congNoNvkdListRequest } = this.props
    var requestData = {};
    return congNoNvkdListRequest(requestData, (data) => {
      this.setState({
        listNvkd: data,
      });
    });
  }
  BuildSelectOption(list, type) {
    const { nvId } = this.state
    var options = [];
    if (list && list.length > 0) {
      if (type == "TINHTHANH") {
        options.push({ value: 0, label: '--Tất cả tỉnh thành--', ma: 0 })
        list.map((item) => { options.push({ value: item.TinhThanhId, label: item.Ten, ma: item.Ma }) });
      }
      if (type == "NVKD") {
        list.map((item) => {
          let option = { value: item.NhanVienId, label: item.TenNhanVien }
          options.push(option)
          if (option.value == nvId) {
            // set selection to skip old value
            this.setState({
              selectedOptionNhanVien: option
            })
          }
        });
      }
    }
    return options;
  }
  checkParams = (callback) => {
    const { location } = this.props
    let nv = getParam(location, "nv", 0);
    let t = getParam(location, "t", this.state.tuNgay.unix());
    let d = getParam(location, "d", this.state.denNgay.unix());
    this.setState({
      tuNgay: moment.unix(t),
      denNgay: moment.unix(d),
      nvId: nv,
      selectedOptionNhanVien: isNumber(nv) ? [parseInt(nv)] : null
    }, callback)
  }
  componentDidMount() {
    this.checkParams(() => {
      this.fetchNvkd()
      this.fetchList(1)
    })
  }

  render() {
    const {
      list,
      selectedOptionNhanVien,
      listNvkd,
    } = this.state

    const {
      handleSubmit,
      congNoNhanVienByKh: {
        listRequesting
      },
    } = this.props
    const getDetailCongNo = (item) => {
      return `/#/congnokh?nv=${item.NhanVienId}&t=${this.state.tuNgay.unix()}&d=${this.state.denNgay.unix()}`
    }
    const startIndex = (this.state.page > 0 ? this.state.page - 1 : 0) * this.state.per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row className="report-control">
                <Col sm="2" xs="6" className="mb-2 pr-0 half-left">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Từ:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.tuNgay}
                      onChange={e => this.handleDateChange(e, "tuNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="2" xs="6" className="mb-2 pr-0 half-right">
                  <InputGroup size="md">
                    <span className="add_date_exs_span">Đến:</span>
                    <DatePicker
                      name="denNgay"
                      placeholder="đến ngày"
                      selected={this.state.denNgay}
                      onChange={e => this.handleDateChange(e, "denNgay")}
                      required className={"form-control add_date_exs_input"}
                      dateFormat="DD/MM/YYYY" />
                  </InputGroup>
                </Col>
                <Col sm="8" className="mb-2">
                  <InputGroup size="md">
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={listNvkd}
                      isMultiChoice={false}
                      checked={selectedOptionNhanVien}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
            <div className="w-100 mb-2 mt-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="mb-0 d-sm-table table-sm table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" rowSpan="2" width="50" className="text-center">#</th>
                    <th scope="col" rowSpan="2" className="text-center">Tên nhân viên</th>
                    <th scope="col" colSpan="2" className="text-center">Đầu kỳ</th>
                    <th scope="col" colSpan="2" className="text-center">Phát sinh</th>
                    <th scope="col" colSpan="2" className="text-center">Cuối kỳ</th>
                  </tr>
                  <tr>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{startIndex + (idx + 1)}</td>
                        <td className="text-left"><a href={getDetailCongNo(res)} target="_blank">{res.TenNhanVien}</a></td>
                        <td className="text-right">{parseFloat(abs2number(res.NoDauKy || 0, res.CoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.CoDauKy || 0, res.NoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.NoCuoiKy || 0, res.CoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.CoCuoiKy || 0, res.NoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="2" className="text-right">
                      Tổng cộng
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_NoDauKy || 0, this.state.total.t_CoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_CoDauKy || 0, this.state.total.t_NoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_NoCuoiKy || 0, this.state.total.t_CoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(abs2number(this.state.total.t_CoCuoiKy || 0, this.state.total.t_NoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.totalRecord > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  congNoNhanVienByKh: state.congNoNhanVienByKh,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  congNoNvkdListRequest: congNoAction.congNoNvkdListRequest,
  congNoNhanVienByKhListRequest: congNoAction.congNoNhanVienByKhListRequest,
  congNoNvExportXlsRequest: congNoAction.congNoNvExportXlsRequest
})(CongNoNhanVienByKh)

const formed = reduxForm({
  form: 'congNoNhanVienByKh',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/CongNoNhanVienByKh.js